export default __webpack_public_path__ + "static/media/error.d3d5dc15.svg";